import { createElementVNode as _createElementVNode, createVNode as _createVNode, withCtx as _withCtx, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, createBlock as _createBlock } from "vue"

const _hoisted_1 = { class: "date-picker-field datepicker__field__inner order-form__input-text" }
const _hoisted_2 = ["id", "value", "placeholder"]

export function render(_ctx, _cache, $props, $setup, $data, $options) {
  return (_openBlock(), _createBlock($setup["DatePickerRoot"], {
    "model-value": $props.modelValue ? $setup.parseAbsolute($props.modelValue.toISOString(), 'UTC') : undefined,
    "min-value": $setup.minDateValue,
    "prevent-deselect": true,
    locale: 'nl',
    "close-on-select": true,
    id: $props.inputId,
    "onUpdate:modelValue": _cache[0] || (_cache[0] = (date) => _ctx.$emit('update:modelValue', date?.toDate('UTC')))
  }, {
    default: _withCtx(() => [
      _createVNode($setup["DatePickerField"], {
        class: "datepicker__field",
        style: {"width":"100%"}
      }, {
        default: _withCtx(({ modelValue }) => [
          _createElementVNode("div", _hoisted_1, [
            _createElementVNode("input", {
              id: `${$props.inputId}-value`,
              readonly: "",
              value: modelValue ? $setup.convertToLocaleDate(modelValue?.toDate('UTC')) : ' ',
              placeholder: $props.placeholder
            }, null, 8 /* PROPS */, _hoisted_2)
          ]),
          _createVNode($setup["DatePickerTrigger"], { class: "datepicker__field__trigger" }, {
            default: _withCtx(() => [
              _createVNode($setup["CalendarIcon"])
            ]),
            _: 1 /* STABLE */
          })
        ]),
        _: 1 /* STABLE */
      }),
      _createVNode($setup["DatePickerAnchor"]),
      _createVNode($setup["DatePickerContent"], {
        position: 'popper',
        "position-strategy": 'absolute',
        class: "datepicker__content"
      }, {
        default: _withCtx(() => [
          _createVNode($setup["DatePickerArrow"], { class: "datepicker__content__arrow" }),
          _createVNode($setup["DatePickerCalendar"], null, {
            default: _withCtx(({ weekDays, grid }) => [
              _createVNode($setup["DatePickerHeader"], { class: "datepicker__content__header" }, {
                default: _withCtx(() => [
                  _createVNode($setup["DatePickerPrev"], null, {
                    default: _withCtx(() => [
                      _createVNode($setup["ChevronLeft"])
                    ]),
                    _: 1 /* STABLE */
                  }),
                  _createVNode($setup["DatePickerHeading"]),
                  _createVNode($setup["DatePickerNext"], null, {
                    default: _withCtx(() => [
                      _createVNode($setup["ChevronRight"])
                    ]),
                    _: 1 /* STABLE */
                  })
                ]),
                _: 1 /* STABLE */
              }),
              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(grid, (month) => {
                return (_openBlock(), _createBlock($setup["DatePickerGrid"], {
                  key: month.value.toString(),
                  class: "datepicker__grid"
                }, {
                  default: _withCtx(() => [
                    _createVNode($setup["DatePickerGridHead"], null, {
                      default: _withCtx(() => [
                        _createVNode($setup["DatePickerGridRow"], null, {
                          default: _withCtx(() => [
                            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(weekDays, (day) => {
                              return (_openBlock(), _createBlock($setup["DatePickerHeadCell"], {
                                key: day,
                                class: "datepicker__grid__cell datepicker__grid__cell--head"
                              }, {
                                default: _withCtx(() => [
                                  _createTextVNode(_toDisplayString(day), 1 /* TEXT */)
                                ]),
                                _: 2 /* DYNAMIC */
                              }, 1024 /* DYNAMIC_SLOTS */))
                            }), 128 /* KEYED_FRAGMENT */))
                          ]),
                          _: 2 /* DYNAMIC */
                        }, 1024 /* DYNAMIC_SLOTS */)
                      ]),
                      _: 2 /* DYNAMIC */
                    }, 1024 /* DYNAMIC_SLOTS */),
                    _createVNode($setup["DatePickerGridBody"], null, {
                      default: _withCtx(() => [
                        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(month.rows, (weekDates, idx) => {
                          return (_openBlock(), _createBlock($setup["DatePickerGridRow"], {
                            key: `weekDate-${idx}`
                          }, {
                            default: _withCtx(() => [
                              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(weekDates, (weekDate) => {
                                return (_openBlock(), _createBlock($setup["DatePickerCell"], {
                                  key: weekDate.toString(),
                                  date: weekDate,
                                  class: "datepicker__grid__cell datepicker__grid__cell--item"
                                }, {
                                  default: _withCtx(() => [
                                    _createVNode($setup["DatePickerCellTrigger"], {
                                      day: weekDate,
                                      month: month.value
                                    }, null, 8 /* PROPS */, ["day", "month"])
                                  ]),
                                  _: 2 /* DYNAMIC */
                                }, 1032 /* PROPS, DYNAMIC_SLOTS */, ["date"]))
                              }), 128 /* KEYED_FRAGMENT */))
                            ]),
                            _: 2 /* DYNAMIC */
                          }, 1024 /* DYNAMIC_SLOTS */))
                        }), 128 /* KEYED_FRAGMENT */))
                      ]),
                      _: 2 /* DYNAMIC */
                    }, 1024 /* DYNAMIC_SLOTS */)
                  ]),
                  _: 2 /* DYNAMIC */
                }, 1024 /* DYNAMIC_SLOTS */))
              }), 128 /* KEYED_FRAGMENT */))
            ]),
            _: 1 /* STABLE */
          })
        ]),
        _: 1 /* STABLE */
      })
    ]),
    _: 1 /* STABLE */
  }, 8 /* PROPS */, ["model-value", "min-value", "id"]))
}